import DataSourceContainer from "../../../../../Components/Forms&Table/Tables/DataTables/DataSource/DataSourcesContainer";

const DataSources = () => {
  return <DataSourceContainer />;
};

export default DataSources;
